import photo from "../../assets/imgs/persons/informationMale.png";
import { useTheme } from "@mui/material";
export default function InformationMaleNoBack({
	backgroundGradinetDark,
	backgroundGradinetLight,
	title,
	highlight,
}) {
	const theme = useTheme();
	return (
		<div style={{ width: "100%", maxWidth: "700px", margin: "0 auto" }}>
			<svg
				width="629"
				height="509"
				viewBox="0 0 629 509"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style={{ width: "100%", height: "auto", display: "block" }}
			>
				<g filter="url(#filter0_d_805_2614)">
					<circle
						cx="450"
						cy="369"
						r="100"
						fill="url(#paint0_linear_805_2614)"
					/>
				</g>
				<rect
					x="233"
					y="224"
					width="368"
					height="245"
					fill="url(#pattern0_805_2614)"
				/>
				<text
					x="70"
					y="180"
					fill={theme.palette.text.main}
					fontWeight="500"
					fontSize="28"
				>
					{title}
				</text>
				<text
					x="70"
					y="215"
					fill={theme.palette.primary.main}
					fontWeight="700"
					fontSize="28"
				>
					{highlight}
				</text>

				<defs>
					<filter
						id="filter0_d_805_2614"
						x="346"
						y="249"
						width="208"
						height="208"
						filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="4" />
						<feGaussianBlur stdDeviation="2" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_805_2614"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_805_2614"
							result="shape"
						/>
					</filter>
					<pattern
						id="pattern0_805_2614"
						patternContentUnits="objectBoundingBox"
						width="1"
						height="1"
					>
						<use
							xlinkHref="#image0_805_2614"
							transform="matrix(0.000651042 0 0 0.000977891 0 -0.000680298)"
						/>
					</pattern>
					<linearGradient
						id="paint0_linear_805_2614"
						x1="350"
						y1="349"
						x2="550"
						y2="349"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor={backgroundGradinetDark} />
						<stop offset="1" stopColor={backgroundGradinetLight} />
					</linearGradient>
					<image
						id="image0_805_2614"
						width="1536"
						height="1024"
						preserveAspectRatio="none"
						href={photo}
					/>
				</defs>
			</svg>
		</div>
	);
}
